import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { ProdutoComentarios, IProdutoComentario } from '../../../../models/produtoComentarios.model';
import { UsersService } from '../../../../models/usuarios.service';
import { Fornecedores } from '../../../../models/fornecedores.model';
import { DataModel } from '../../../../models/data.model';



@Component({
    selector: 'comentarios-list',
    template: `
    <div *ngIf="items.length>0" >  
        <mat-divider></mat-divider>
        <div class="title">Estão comentando</div>
        <mat-vertical-stepper>
            <mat-step *ngFor="let item of items"  label="{{toDateLocale(item.data)}} {{item.usuario}} ">
                {{item.mensagem}}
            </mat-step>
        </mat-vertical-stepper>
    </div>
    `,
    styles: [``]
})

export class ComentariosListComponent implements OnInit {
    fFornecedor: number = 0;
    items:IProdutoComentario[] = [];
    itemsClass: ProdutoComentarios;

    @Input()
    get fornecedor() {
        return this.fFornecedor;
    }
    set fornecedor(x) {
        if (x != undefined)
            if (this.fFornecedor != x){
                this.fFornecedor = x;
                if (x > 0)
                    this.itemsClass.getComentariosAbertos(x,
                        d => {
                            this.items = d;
                        })
            }
    }

    constructor(
        private db: AngularFirestore,
        private users: UsersService
    ) {
        this.itemsClass = new ProdutoComentarios(this.db, 0, '', this.users);
        this.fornecedor = users.usuario.fornecedor;
    }

    ngOnInit(): void {
    }

    toDateLocale(d){
        return DataModel.toDateLocale(d);
    }
}
